import React from 'react';
import { AppPaper } from '../../layout/appPaper';
import { Activity } from '../../models/activity';
import { AppCalendarActivity } from '../app/appCalendarActivity/appCalendarActivity';

interface Props {
  dateActivity: Date;
  location?: string;
  activities: Activity[];
  onSelectDay(date: string): void;
  onSelectWeek(weekNumber: number): void;
  showOnlyloggedTime?: boolean;
  employeeWorkHours?: number;
}

export function ActivityMonth({
  dateActivity,
  activities,
  onSelectDay,
  location,
  onSelectWeek,
  showOnlyloggedTime = false,
  employeeWorkHours,
}: Props): JSX.Element {
  return (
    <AppPaper isMobile={false}>
      <AppCalendarActivity
        referenceDate={dateActivity}
        activities={activities}
        location={location}
        onSelectDay={onSelectDay}
        onSelectWeek={onSelectWeek}
        showOnlyloggedTime={showOnlyloggedTime}
        employeeWorkHours={employeeWorkHours}
      />
    </AppPaper>
  );
}
